//
//
//
//
//
//
//
//
//
//

import { isElectron } from '@/utils/constants';

export default {
  data() {
    return {
      isClient: false
    }
  },
  computed: {
      colorMode() {
        return this.$store.state.user.colorMode || 'light';
      },
  },
  created() {
    if (process.server) {
      const ua = this.$ssrContext.req.headers['user-agent'];
      this.isClient = isElectron(ua);
    }
  },
  mounted() {
    if (process.client && window) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      if (!window.zc) {
        (function (window, document, brandMark) {
          // eslint-disable-next-line no-unused-vars
          window[brandMark] = function () {
            window.cbk = window.cbk || [];
            // eslint-disable-next-line prefer-rest-params
            window.cbk.push(arguments);
          }
          const scriptDom = document.createElement("script");
          scriptDom.async = true;
          scriptDom.id = "zhichiScript";
          scriptDom.className="zc-sdk-btn";
          scriptDom.src = "https://mg.soboten.com/chat/frame/v6/entrance.js?sysnum=fdd39f0450084365b2e4a7d9d99ac553";
          document.body.appendChild(scriptDom);
        })(window, document, "zc");
        const { name, email, phoneNumber, id, } = userInfo;
        window.zc('config', {
          color: '2878ff',
          robotid: 2,
          location: 1, 
          custom: true, 
          man_trace: true, 
          type: 3,
          uname: name || '', 
          email: email || '', 
          tel: phoneNumber || '', 
          customer_fields: JSON.stringify({
            'userId': id || '',
          }),
          channelid: 4,
          schemeId: '1681933162170826752',
          transfer_action: JSON.stringify({ 
            deciId: '31f6a02d1da94c8da1a907c5c9119850',
            optionId: '4', 
            actionType: 'to_group',
          })
        })
      }
    }
  }
}
